import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "src/app/services/user.service";
import { UtmTrackingService } from "src/app/services/utm-tracking.service";
import { NeoComunService } from "../../services/neoComun.service";

declare var $: any;

@Component({
    selector: 'app-log-out',
    templateUrl: './log-out.component.html',
    styleUrls: ['./log-out.component.scss'],
    providers: [
        NeoComunService
    ],
    standalone: false
})
export class LogOutComponent {
  constructor(
    private _user: UserService,
    private router: Router,
    private readonly utmTracking: UtmTrackingService
  ) {
    $('.modal-backdrop').remove();
  }
  async logOut() {
    this.utmTracking.registrarFinalizacionSesion();
    await this._user.deleteUser();
    this.router.navigateByUrl('/home');
  }
}
